module.exports = __webpack_public_path__ + "static/incense-73104dff34ea010270e65012dd3ef224.jpg";